import gql from 'graphql-tag';
import { query } from '../../client';
export const MEMBERSHIP_BY_EMAIL = gql `
  query memberByEmail($email: EmailAddress!, $status: AssetStatus) {
    member {
      byEmail(input: { email: $email, status: $status }) {
        __typename
        ... on Member {
          id
          sourceSystem
          assets {
            __typename
            ... on MembershipAsset {
              __typename
              id
              product {
                __typename
                id
                type
                code
                price {
                  amount
                  currency
                }
                isVIP
                level
                name
                omniInventoryId
                skuCode
              }
              status
              affiliation
              amountPaid {
                amount
                currency
              }
              activatedDate
              effectiveAt
              expireAt
              omniMembershipId
              omniOrderId
              subscriptionStatus
            }
          }
        }
        ... on MemberByEmailFailure {
          errors {
            __typename
            ... on MemberByEmailError {
              __typename
              ... on MemberNotFoundError {
                message
              }
            }
            ... on DomainError {
              message
            }
          }
        }
      }
    }
  }
`;
export function getMembershipByEmail(email, status = 'ACTIVE') {
    return query({
        query: MEMBERSHIP_BY_EMAIL,
        variables: { email, status },
    });
}
export default getMembershipByEmail;
